/** České kraje — HR profil zaměstnance (kraj ≠ pobočka). */
export const CZECH_KRAJ_OPTIONS = [
  'Hlavní město Praha',
  'Středočeský kraj',
  'Jihočeský kraj',
  'Plzeňský kraj',
  'Karlovarský kraj',
  'Ústecký kraj',
  'Liberecký kraj',
  'Královéhradecký kraj',
  'Pardubický kraj',
  'Vysočina',
  'Jihomoravský kraj',
  'Olomoucký kraj',
  'Zlínský kraj',
  'Moravskoslezský kraj',
] as const;

export type CzechKraj = (typeof CZECH_KRAJ_OPTIONS)[number];

export function normalizeCzechKraj(value: unknown): string | null {
  const s = String(value ?? '').trim();
  if (!s) return null;
  const match = CZECH_KRAJ_OPTIONS.find((k) => k.toLowerCase() === s.toLowerCase());
  return match ?? s.slice(0, 128);
}
